class FAQManager {
  constructor() {
    // DOM Elements
    this.contentWrapper = document.querySelector(".faq__content-wrapper");
    this.faqItems = document.querySelectorAll(".faq__item");
    this.faqItemsContainer = document.querySelector(".faq__items");
    this.faqDetails = document.querySelectorAll(".faq-details");
    this.faqNav = document.querySelector(".faq__nav");
    this.faqTitle = document.querySelector(".faq__title");
    this.faqDetailsText = document.querySelectorAll(".faq-details__item-text");
    this.allQuestionsBtn = document.querySelector(
      ".faq__breadcrumbs-item--all"
    );
    this.activeBreadcrumb = document.querySelector(
      ".faq__breadcrumbs-item--active"
    );
    this.searchInput = document.querySelector(".faq__search-input");
    this.searchContainer = document.querySelector(".faq__search");

    // State
    this.basePath = window.location.pathname;
    this.searchParams = window.location.search;
    this.searchIndex = [];
    this.searchTimeout = null;

    // Initialize
    this.init();
  }

  init() {
    // Set initial height
    this.contentWrapper.style.height =
      this.faqItemsContainer.clientHeight + "px";

    this.faqItemsContainer.style.position = "absolute";

    // Hide nav initially
    this.faqNav.classList.remove("faq__nav--details");

    // Hide all FAQ details
    this.faqDetails.forEach((detail) => {
      detail.classList.add("faq-details--hidden");
    });

    // Build search index
    this.buildSearchIndex();

    // Create search dropdown
    this.createSearchDropdown();

    // Bind events
    this.bindEvents();

    // Check initial URL
    this.checkInitialURL();

    // Handle read more functionality
    this.handleReadMore();
  }

  buildSearchIndex() {
    this.faqItems.forEach((item) => {
      const itemId = item.getAttribute("data-id");
      const itemHandle = item.getAttribute("data-handle");
      const itemTitle = item.querySelector(".faq__item-title").textContent;

      // Add main category to index
      this.searchIndex.push({
        id: itemId,
        handle: itemHandle,
        title: itemTitle,
        type: "category",
        text: itemTitle.toLowerCase(),
      });

      // Add individual FAQ items to index
      const detailsContainer = document.querySelector(
        `.faq-details[data-id="${itemId}"]`
      );
      if (detailsContainer) {
        const detailItems =
          detailsContainer.querySelectorAll(".faq-details__item");
        detailItems.forEach((detailItem, index) => {
          const detailTitle =
            detailItem.querySelector(".faq-details__item-title")?.textContent ||
            "";
          const detailText =
            detailItem.querySelector(".faq-details__item-text")?.textContent ||
            "";

          this.searchIndex.push({
            id: itemId,
            handle: itemHandle,
            categoryTitle: itemTitle,
            title: detailTitle,
            type: "item",
            itemIndex: index,
            text: (detailTitle + " " + detailText).toLowerCase(),
          });
        });
      }
    });
  }

  createSearchDropdown() {
    this.suggestionsDropdown = document.createElement("div");
    this.suggestionsDropdown.className = "faq__search-suggestions";
    this.suggestionsDropdown.style.cssText = `
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: white;
      border: 1px solid #ddd;
      border-top: none;
      max-height: 300px;
      overflow-y: auto;
      display: none;
      z-index: 1000;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    `;
    this.searchContainer.style.position = "relative";
    this.searchContainer.appendChild(this.suggestionsDropdown);
  }

  handleResize() {
    const activeDetails = document.querySelector(
      ".faq-details:not(.faq-details--hidden)"
    );
    const height = activeDetails
      ? activeDetails.clientHeight
      : this.faqItemsContainer.clientHeight;

    this.contentWrapper.style.height = height + "px";
  }

  bindEvents() {
    window.addEventListener("resize", () => {
      this.handleResize();
      this.handleReadMore();
    });

    // FAQ item clicks
    this.faqItems.forEach((item) => {
      item.addEventListener("click", () => this.handleFaqItemClick(item));
    });

    // All questions breadcrumb
    if (this.allQuestionsBtn) {
      this.allQuestionsBtn.style.cursor = "pointer";
      this.allQuestionsBtn.addEventListener("click", () =>
        this.showMainView(true)
      );
    }

    // Search input
    this.searchInput.addEventListener("input", (e) =>
      this.handleSearchInput(e)
    );

    // Search suggestions clicks
    this.suggestionsDropdown.addEventListener("click", (e) =>
      this.handleSuggestionClick(e)
    );

    // Click outside to close search
    document.addEventListener("click", (e) => this.handleDocumentClick(e));

    // Browser navigation
    window.addEventListener("popstate", (e) => this.handlePopState(e));
  }

  updateURL(handle = null) {
    const url = new URL(window.location.href);
    if (handle) {
      url.searchParams.set("faq", handle);
    } else {
      url.searchParams.delete("faq");
    }
    window.history.pushState({ faqHandle: handle }, "", url.toString());
  }

  showMainView(updateHistory = true) {
    // Show FAQ items
    this.faqItemsContainer.classList.remove("faq__items--hidden");

    // Hide all FAQ details
    this.faqDetails.forEach((detail) => {
      detail.classList.add("faq-details--hidden");
    });

    // Show main title
    if (this.faqTitle) {
      this.faqTitle.style.display = "";
    }

    // Hide nav details
    this.faqNav.classList.remove("faq__nav--details");

    // Reset content wrapper height
    this.contentWrapper.style.height =
      this.faqItemsContainer.clientHeight + "px";

    // Update URL if needed
    if (updateHistory) {
      this.updateURL();
    }
  }

  showDetailsView(
    itemId,
    itemTitle,
    itemHandle,
    updateHistory = true,
    scrollToItem = null
  ) {
    // Hide items container
    this.faqItemsContainer.classList.add("faq__items--hidden");

    // hide all FAQ details
    this.faqDetails.forEach((detail) => {
      detail.classList.add("faq-details--hidden");
    });

    // Show the corresponding FAQ details
    const targetDetail = document.querySelector(
      `.faq-details[data-id="${itemId}"]`
    );
    if (targetDetail) {
      targetDetail.classList.remove("faq-details--hidden");

      // Update content wrapper height and handle scrolling
      setTimeout(() => {
        this.contentWrapper.style.height = targetDetail.clientHeight + "px";

        if (scrollToItem !== null) {
          this.scrollToSpecificItem(targetDetail, scrollToItem);
        }
      }, 10);
    }

    // Hide main title
    if (this.faqTitle) {
      this.faqTitle.style.display = "none";
    }

    // Show nav details
    this.faqNav.classList.add("faq__nav--details");

    // Update active breadcrumb text
    if (this.activeBreadcrumb && itemTitle) {
      this.activeBreadcrumb.textContent = itemTitle;
    }

    // Update URL if needed
    if (updateHistory && itemHandle) {
      this.updateURL(itemHandle);
    }

    // Scroll to top of the content wrapper
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  scrollToSpecificItem(container, itemIndex) {
    const items = container.querySelectorAll(".faq-details__item");
    if (items[itemIndex]) {
      setTimeout(() => {
        window.scrollTo({
          top: items[itemIndex].offsetTop - 100, // Adjust offset as needed
          behavior: "smooth",
        });

        // Highlight the item briefly
        items[itemIndex].style.backgroundColor = "#ffffcc";
        setTimeout(() => {
          items[itemIndex].style.transition = "background-color 1s ease";
          items[itemIndex].style.backgroundColor = "";
        }, 500);
      }, 300);
    }
  }

  getFaqItemByHandle(handle) {
    return document.querySelector(`.faq__item[data-handle="${handle}"]`);
  }

  performSearch(query) {
    if (!query || query.length < 2) {
      this.suggestionsDropdown.style.display = "none";
      return;
    }

    const lowerQuery = query.toLowerCase();
    const results = this.searchIndex.filter((item) =>
      item.text.includes(lowerQuery)
    );

    if (results.length === 0) {
      this.suggestionsDropdown.innerHTML =
        '<div style="padding: 10px; color: #666;">No results found</div>';
      this.suggestionsDropdown.style.display = "block";
      return;
    }

    this.displaySearchResults(results.slice(0, 10), query);
  }

  displaySearchResults(results, query) {
    const html = results
      .map((result) => {
        const highlightedTitle = this.highlightMatch(result.title, query);

        return `
        <div class="faq__search-suggestion" 
             data-id="${result.id}" 
             data-handle="${result.handle}" 
             data-type="${result.type}"
             data-item-index="${result.itemIndex || ""}"
             style="padding: 10px; cursor: pointer; border-bottom: 1px solid #eee;">
          ${
            result.type === "category"
              ? `<strong>${highlightedTitle}</strong>`
              : `<div><small style="color: #666;">${result.categoryTitle}</small></div>
             <div>${highlightedTitle}</div>`
          }
        </div>
      `;
      })
      .join("");

    this.suggestionsDropdown.innerHTML = html;
    this.suggestionsDropdown.style.display = "block";

    // Add hover effects
    this.addSearchHoverEffects();
  }

  addSearchHoverEffects() {
    const suggestions = this.suggestionsDropdown.querySelectorAll(
      ".faq__search-suggestion"
    );
    suggestions.forEach((suggestion) => {
      suggestion.addEventListener("mouseenter", function () {
        this.style.backgroundColor = "#f5f5f5";
      });
      suggestion.addEventListener("mouseleave", function () {
        this.style.backgroundColor = "";
      });
    });
  }

  highlightMatch(text, query) {
    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(
      regex,
      '<mark style="background-color: #ffeb3b; padding: 0 2px;">$1</mark>'
    );
  }

  // Event Handlers
  handleFaqItemClick(item) {
    const itemId = item.getAttribute("data-id");
    const itemHandle = item.getAttribute("data-handle");
    const itemTitle = item.querySelector(".faq__item-title").textContent;

    this.showDetailsView(itemId, itemTitle, itemHandle, true);
  }

  handleSearchInput(e) {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.performSearch(e.target.value);
    }, 200);
  }

  handleSuggestionClick(e) {
    const suggestion = e.target.closest(".faq__search-suggestion");
    if (suggestion) {
      const itemId = suggestion.getAttribute("data-id");
      const itemHandle = suggestion.getAttribute("data-handle");
      const itemType = suggestion.getAttribute("data-type");
      const itemIndex = suggestion.getAttribute("data-item-index");

      const faqItem = this.getFaqItemByHandle(itemHandle);
      if (faqItem) {
        const itemTitle = faqItem.querySelector(".faq__item-title").textContent;
        const scrollTo =
          itemType === "item" && itemIndex ? parseInt(itemIndex) : null;
        this.showDetailsView(itemId, itemTitle, itemHandle, true, scrollTo);
      }

      // Clear search
      this.searchInput.value = "";
      this.suggestionsDropdown.style.display = "none";
    }
  }

  handleDocumentClick(e) {
    if (!this.searchContainer.contains(e.target)) {
      this.suggestionsDropdown.style.display = "none";
    }
  }

  handlePopState(event) {
    const urlParams = new URLSearchParams(window.location.search);
    const faqHandle = urlParams.get("faq");

    if (faqHandle) {
      const faqItem = this.getFaqItemByHandle(faqHandle);
      if (faqItem) {
        const itemId = faqItem.getAttribute("data-id");
        const itemTitle = faqItem.querySelector(".faq__item-title").textContent;
        this.showDetailsView(itemId, itemTitle, faqHandle, false);
      } else {
        this.showMainView(false);
      }
    } else {
      this.showMainView(false);
    }
  }

  checkInitialURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const initialFaqHandle = urlParams.get("faq");

    if (initialFaqHandle) {
      const faqItem = this.getFaqItemByHandle(initialFaqHandle);
      if (faqItem) {
        const itemId = faqItem.getAttribute("data-id");
        const itemTitle = faqItem.querySelector(".faq__item-title").textContent;
        this.showDetailsView(itemId, itemTitle, initialFaqHandle, false);
      }
    }
  }

  handleReadMore() {
    this.faqDetailsText.forEach((text) => {
      const fullHeight = text.scrollHeight;
      const displayHeight = text.clientHeight;
      const hasReadMore = text.classList.contains(
        "faq-details__item-text--read-more"
      );
      if (fullHeight > displayHeight && !hasReadMore) {
        text.classList.add("faq-details__item-text--read-more");
        const readMoreBtn = document.createElement("button");
        readMoreBtn.className = "faq-details__read-more";
        readMoreBtn.textContent = "Read more >";
        text.parentElement.appendChild(readMoreBtn);

        readMoreBtn.addEventListener("click", () => {
          const image = text
            .closest(".faq-details__item")
            .querySelector(".faq-details__item-image");

          const diff = fullHeight - displayHeight;
          const activeDetails = text.closest(".faq-details");
          const height = activeDetails ? activeDetails.clientHeight : 0;

          if (text.style.maxHeight) {
            text.style.maxHeight = "";
            text
              .closest(".faq-details__item")
              .classList.remove("faq-details__item--expanded");
            readMoreBtn.textContent = "Read more >";
            this.contentWrapper.style.height = height - diff + "px";
          } else {
            text.style.maxHeight = fullHeight + "px";
            readMoreBtn.textContent = "Read less >";
            this.contentWrapper.style.height = height + diff + "px";
            text
              .closest(".faq-details__item")
              .classList.add("faq-details__item--expanded");
          }
        });
      } else if (fullHeight <= displayHeight && hasReadMore) {
        // If the text fits, remove the read more button
        const readMoreBtn = text.parentElement.querySelector(
          ".faq-details__read-more"
        );
        if (readMoreBtn) {
          readMoreBtn.remove();
        }
        text.classList.remove("faq-details__item-text--read-more");
      }
    });
  }
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", function () {
  new FAQManager();
});
document.addEventListener("shopify:section:load", function () {
  new FAQManager();
});
